<template lang="pug">
.v-calculator-page.calculator-page(v-if="data")
	.calculator__head.page-head(v-if="data.title")
		component.page-head__title(
			:is="data.titleLevel ? data.titleLevel : 'h1'"
			:class="data.titleStyleLevel")
			| {{data.title}}
	v-calculator.calculator__body(:data-source="data")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null,
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},
	},


}

</script>